import { useEffect } from 'react';

import Screen from '../../components/screen';
import GlobalStyles from '../../global-styles';
import { goToRoutePage, setWindowTitle } from '../../utils/helper';
import { Box, Breadcrumbs, Grid, Link, Typography } from '../../utils/material-ui-core';
import AddressValidator from './address-validator';
import EmailValidator from './email-validator';
import PhoneValidator from './phone-validator';

const Validation = () => {
  const globalStyles = GlobalStyles();

  useEffect(() => {
    setWindowTitle("Onboarding - Client Company");
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen>
      <Grid container spacing={3}>
        <Grid item xs={10} sm={10} md={10} lg={10}>
          <Box className={globalStyles.bottomSpacer}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" onClick={() => goToRoutePage("home")} className={globalStyles.link}>
                Home
              </Link>
              <Typography color="textPrimary">Validation</Typography>
            </Breadcrumbs>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <AddressValidator />
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>&nbsp;</Box>
          <PhoneValidator />
        </Grid>
        <Grid item xs={12}>
          <Box p={1}>&nbsp;</Box>
          <EmailValidator />
        </Grid>
      </Grid>
    </Screen>
  );
};

export default Validation;
